<template>
  <Box>
    <div class="box-content">
      <div class="title">{{ $t('promotion.referFriends.referralLink') }}</div>
      <div v-if="referralLink">
        <ClipboardCopy :value="referralLink" @copy="onCopy" @error="onError" />
        <AddToAny v-if="referralLink" class="add-to-any" title="REFER A FRIEND" :url="referralLink" />
      </div>
      <div v-else>
        <p>{{ $t('promotion.referFriends.emptyReferralLink') }}</p>
      </div>
    </div>
  </Box>
</template>

<script>
import Box from '@/components/box/Box.vue';
import ClipboardCopy from '@/components/clipboard-copy/ClipboardCopy.vue';
import AddToAny from '@/components/add-to-any/AddToAny.vue';

export default {
  name: 'Referral',
  props: {
    campaignId: Number,
    referralLink: String
  },
  components: {
    Box,
    ClipboardCopy,
    AddToAny
  },
  methods: {
    onCopy(e) {
      this.$message({
        message: this.$t('common.field.successful'),
        type: 'success'
      });
    },
    onError(e) {
      this.$message({
        message: this.$t('common.field.failed'),
        type: 'error'
      });
    }
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/overview/referral.scss';
</style>
